import { render, staticRenderFns } from "./AnimateNewYear.vue?vue&type=template&id=02131ace&"
import script from "./AnimateNewYear.vue?vue&type=script&lang=js&"
export * from "./AnimateNewYear.vue?vue&type=script&lang=js&"
import style0 from "./AnimateNewYear.vue?vue&type=style&index=0&id=02131ace&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports